import { render, staticRenderFns } from "./ContractNew.vue?vue&type=template&id=5c5d3185&"
import script from "./ContractNew.vue?vue&type=script&lang=ts&"
export * from "./ContractNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports